export const AmProtCustomizableDropDownOptionFragment = /* GraphQL */ `
  fragment AmProtCustomizableDropDownOptionFragment on AmProtCustomizableDropDownOption {
    values {
      uid
      option_id
      value_index
      default_label
      label
      price
      sku
      swatch_data {
        type
        value
        thumbnail
      }
      color_image {
        fabric
        url
      }
    }
  }
`;

export const AmProtCustomizableRadioOptionFragment = /* GraphQL */ `
  fragment AmProtCustomizableRadioOptionFragment on AmProtCustomizableRadioOption {
    values {
      uid
      option_id
      value_index
      default_label
      label
      price
      sku
      swatch_data {
        type
        value
        thumbnail
      }
      color_image {
        fabric
        url
      }
    }
  }
`;

export const ProductAmpFragment = /* GraphQL */ `
  fragment ProductAmpFragment on ProductInterface {
    ampProtOption {
      items {
        uid
        label
        default_label
        attribute_id
        type
        sort_order
        ...AmProtCustomizableDropDownOptionFragment
        ...AmProtCustomizableRadioOptionFragment
      }
    }
  }

  ${AmProtCustomizableDropDownOptionFragment}
  ${AmProtCustomizableRadioOptionFragment}
`;

export const ProductBaseDetailFragment = /* GraphQL */ `
  fragment ProductBaseDetailFragment on ProductInterface {
    id
    uid
    version
    change_style
    __typename
    rating_summary
    review_count
    reviews {
      fabricData {
        label
        value
      }
      fabricReviewCounts(product_id: $product_id) {
        id
        value
      }
    }
    categories {
      uid
      name
      url_key
      breadcrumbs {
        category_uid
        category_id
      }
    }
    shipping_type
    video_url
    ready_to_ship_product_url
    estimate_delivery {
      code
      value
    }
    special_price
    description {
      html
    }
    short_description {
      html
    }
    question_answer {
      author
      email
      question
      answer
      date
    }
    notes
    is_try_on
    try_on_map_sku
    robes_gifts_customization
    order_free_swatch {
      label
      href
    }
    media_gallery_entries {
      uid
      label
      position
      disabled
      file
    }
    media_gallery {
      label
      url(width: 90, height: 132)
      thumbnail: url(type: "thumbnail", width: 90, height: 132)
      image: url(type: "image", width: 692, height: 1016)
      position
      disabled
    }
    name
    price {
      regularPrice {
        amount {
          currency
          value
        }
      }
    }
    price_range {
      maximum_price {
        final_price {
          currency
          value
        }
        discount {
          amount_off
        }
        regular_price {
          currency
          value
        }
      }
      minimum_price {
        final_price {
          currency
          value
        }
        regular_price {
          currency
          value
        }
        discount {
          amount_off
        }
      }
    }
    sku
    show_attribute {
      label
      code
      id
      value
    }
    small_image {
      url(type: "thumbnail", width: 90, height: 132)
    }
    stock_status
    product_mark
    url_key
  }
`;

export const ProductConfigurableInfoFragment = /* GraphQL */ `
  fragment ProductConfigurableInfoFragment on ConfigurableProduct {
    configurable_options {
      attribute_code
      attribute_id
      uid
      label
      default_label
      product_id
      position
      values {
        uid
        default_label
        label
        store_label
        use_default_value
        value_index
        swatch_data {
          ... on ImageSwatchData {
            thumbnail
          }
          value
        }
      }
    }
    variants {
      attributes {
        code
        value_index
      }
      product {
        id
        uid
        media_gallery_entries {
          uid
          disabled
          file
          label
          position
        }
        media_gallery {
          label
          url(width: 90, height: 132)
          thumbnail: url(type: "thumbnail", width: 90, height: 132)
          image: url(type: "image", width: 692, height: 1016)
          position
          disabled
        }
        sku
        stock_status
        price {
          regularPrice {
            amount {
              currency
              value
            }
          }
        }
        price_range {
          maximum_price {
            final_price {
              currency
              value
            }
            discount {
              amount_off
            }
            regular_price {
              currency
              value
            }
          }
          minimum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
            discount {
              amount_off
            }
          }
        }
      }
    }
  }
`;

export const AccessoriesRecommendationProductFragment = /* GraphQL */ `
  fragment AccessoriesRecommendationProductFragment on ProductInterface {
    id
    uid
    name
    version
    price_range {
      maximum_price {
        final_price {
          currency
          value
        }
        regular_price {
          currency
          value
        }
        discount {
          amount_off
        }
      }
      minimum_price {
        final_price {
          currency
          value
        }
        regular_price {
          currency
          value
        }
        discount {
          amount_off
        }
      }
    }
    sku
    image {
      url(type: "thumbnail", width: 692, height: 1016)
    }
    hover_image(width: 692, height: 1016)
    show_colors(width: 692, height: 1016, filter_color: $filter_color, filter_fabric: $filter_fabric) {
      items {
        label
        rgb
        image
        hover_image
        is_selected
        is_change_url
        fabric
      }
      total
    }
    __typename
    url_key
  }
`;
